export function Brand({
  compact = false,
  club = false,
  href = "/",
}: {
  compact?: boolean;
  club?: boolean;
  href?: string;
}) {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const target = new URL(href, window.location.href);
    const normalizePath = (path: string) => path.replace(/\/+$/, "") || "/";
    if (
      target.origin === window.location.origin &&
      normalizePath(target.pathname) === normalizePath(window.location.pathname) &&
      target.search === window.location.search &&
      target.hash === window.location.hash
    ) {
      event.preventDefault();
    }
  };

  if (club) {
    return (
      <a
        aria-label="Hello World UNAM"
        className="brand brand--club"
        href={href}
        onClick={handleClick}
      >
        <img alt="" aria-hidden="true" src="/helloworld-mark.png" />
        <span className="brand-club-wordmark">
          <strong>
            Hello <em>World</em>
          </strong>
        </span>
      </a>
    );
  }

  return (
    <a className="brand" href={href} onClick={handleClick} aria-label="¿Cuánto cuesta tu nube?">
      <span className="brand-mark" aria-hidden="true">
        ☁
      </span>
      {!compact && (
        <span>
          <strong>Tu nube</strong>
          <small>Hello World · UNAM</small>
        </span>
      )}
    </a>
  );
}

export function StatusBadge({
  children,
  tone = "purple",
}: {
  children: React.ReactNode;
  tone?: "purple" | "green" | "yellow" | "muted";
}) {
  return <span className={`hw-badge hw-badge--${tone}`}>{children}</span>;
}
